<template>
    <div class="w-0 my-2 mx-2 mx-lg-0 mx-md-0">
        <div :class="{'position-absolute select-label fs-7': isStyled}" v-if="label.length" :style="{backgroundColor: bgColor}">
            {{ label }}
        </div>
        <div class="rounded-0 w-100 p-2 fs-6 bg-transparent border border-2" 
            style="border: 2px solid rgba(0,0,0,0.2) !important;">
            <input v-model="modelValueRef" type="number" min="0" class="bg-transparent border-0 focus-0 w-100"/>
        </div>
    </div>
</template>

<script setup>
import { useVModel } from "@/fuel-station/useVModel";

const props = defineProps({
    modelValue: {
        type: [Object, Array, String, Number],
        default: 0,
    },
    label: {
        type: String,
        default: ""
    },
    textClass: {
        type: String,
        default: ""
    },
    isStyled: {
        type: Boolean,
        default: true
    },
    bgColor: {
        type: String,
        default: "#fff"
    }
});

const emit = defineEmits(['update:modelValue']);
const modelValueRef = useVModel(props, emit, "modelValue");
</script>

<style lang="scss" scoped>
.select-label {
    top: -10px;
    left: 13px;
    z-index: 99;
    padding: 0 5px;
}

.form-select:focus {
    border-color: none !important;
    box-shadow: none !important;
}

p {
    min-height: 24px !important;
    max-height: 24px !important;
}

textarea:focus, input:focus{
    outline: none;
}
</style>